<template>
    <div>
    <div style="display: flex;" class="mb-5">
        <div>
        <label>Pays</label>
        <vs-input class="mr-5" v-model="thisThema.country"></vs-input>
        </div>

        <div>
        <label>Niveau</label>
        <vs-input type="number" v-model="thisThema.level"></vs-input>
        </div>

        
    </div>
<vs-button
    @click="saveThema(thisThema)">Enregistrer</vs-button>
</div>
  </template>

<script>
import request from "@/axios.js";
import store from "@/store/store";
export default {
	name: "NetlinkThemaIntlPopup",
	props: {
		isPopupActive: Boolean,
		isEdit: Boolean,
		thematique: Object

	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			thisThema: this.$props.isEdit?
				this.$props.thematique:
				{country: "", level: 0, percent: 0}
		};
	},
	created(){
		this.thisThema = this.$props.isEdit? this.$props.thematique: {country: "", level: 0, percent: 0};
	},
	computed: {
		// netlinkThemaList: () => {
		// 	return store.state.netlinkThemas;
		// }
	},
	watch: {
		"$props.thematique": function(data){
			this.thisThema = data;
		}
	},
	methods: {
		saveThema(thema){
			if(this.$props.isEdit) this.editThema(thema);
			else this.newThema(thema);
		},
		async editThema(thisThema){
			try{
				await request.post("/netlink/netlinkIntl/edit", thisThema);
				this.$vs.notify({
					title: "Succès",
					text: "Thématique modifié avec succès."
				});
				store.dispatch("getAllNetlinkThemaList");
				this.$emit("close-intl-popup", "");

			}
			catch(err){
				this.$vs.notify({
					title: "Echec",
					text: "Error " + err.toString()
				});
			}
		},
		async newThema(thisThema){
			try{
				await request.post("/netlink/netlinkIntl/new", thisThema);
				this.$vs.notify({
					title: "Succès",
					text: "Thématique ajouté avec succès."
				});
				store.dispatch("getAllNetlinkThemaList");
				this.$emit("close-intl-popup", "");

			}
			catch(err){
				this.$vs.notify({
					title: "Echec",
					text: "Error " + err.toString()
				});
			}
		}
	}
	// Your component's properties and methods here
};
</script>

